import './App.css';
import 'rsuite/Table/styles/index.css';
import 'rsuite/Input/styles/index.css';
import 'rsuite/InputGroup/styles/index.css';
import 'rsuite/Button/styles/index.css';
import 'rsuite/DatePicker/styles/index.css';
import FomoCrypto from './CryptoComponent';

function App() {
    return (
        <div>
            <FomoCrypto/>
        </div>
    );
}

export default App;
